import { render, staticRenderFns } from "./override-modal.vue?vue&type=template&id=0bb86b79"
import script from "./override-modal.vue?vue&type=script&lang=js"
export * from "./override-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports